export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11930.57380267.jpg";